import { Platform, Pressable, StyleSheet, TouchableOpacity, View } from 'react-native';

import { getName } from '@pletly/shared';
import { colors, spacing, usePressable, AcceptIcon, CancelIcon } from '@pletly/ui';
import { UserInfo } from '%components';
import { GetInvitations_currentUser_superPalOf_friendshipRequestsReceived_fromUser } from '%context/Invitations/__generated__/GetInvitations';

const dummyOnPress = () => null;

const getUserInfoProps = ({ user, email }: Pick<Props, 'user' | 'email'>) => {
	if (email) {
		return {
			name: email,
		};
	}

	if (user) {
		return {
			id: `${user.id}`,
			name: getName(user),
			photoUrl: user.photoUrl,
		};
	}
};

export const Invite = ({ user, email, onAccept, onDecline, noProfilePress }: Props) => {
	const { isHovered, onHoverIn, onHoverOut } = usePressable();

	return (
		<Pressable
			style={[styles.invite, isHovered && styles.hovered]}
			onHoverIn={onHoverIn}
			onHoverOut={onHoverOut}
		>
			<UserInfo
				bolded={Platform.OS !== 'web'}
				onPress={noProfilePress ? dummyOnPress : undefined}
				size={Platform.select({ web: 48, default: undefined })}
				{...getUserInfoProps({ user, email })}
			/>
			<View style={styles.actions}>
				{onAccept && (
					<TouchableOpacity style={styles.button} onPress={onAccept}>
						<AcceptIcon />
					</TouchableOpacity>
				)}
				<TouchableOpacity style={styles.button} onPress={onDecline}>
					<CancelIcon />
				</TouchableOpacity>
			</View>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	invite: {
		flex: 1,
		flexDirection: 'row',
		padding: spacing(2),
		alignItems: 'center',
	},
	actions: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	button: {
		marginLeft: spacing(2),
	},
	hovered: {
		backgroundColor: colors.neutral300,
	},
});

type Props = (UserInviteProps | EmailInviteProps) & CommonProps;

type UserInviteProps = {
	user: GetInvitations_currentUser_superPalOf_friendshipRequestsReceived_fromUser;
	email?: never;
};

type EmailInviteProps = {
	email: string;
	user?: never;
};

type CommonProps = {
	onAccept?: () => void;
	onDecline: () => void;
	noProfilePress?: boolean;
};
